module.exports = __webpack_public_path__ + "img/pentagon.eaaae17e.svg";